import React from 'react';

import InputMask from './InputMask';

const InputCellPhone = React.forwardRef(
    (props, ref) => {

        return (
            <InputMask
                mask={'(00) 00000-0000'}
                {...props}
                ref={ref}
            />
        );
    });
export default InputCellPhone;
